import data from "../../.sourceflow/tbd_culture_page_tablist_section.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const tbd_helper = new CollectionHelper(data);
